export const CTA_BUTTON_TEXT = "לבדיקת רקע חינם"